
export default {
    // 查询消费者下拉框
    queryConsumerInfo (params, response) {
        window.vue.$apiAxios.get('/databusserver/interfaceManager/listBoundChannelSrcInfo', params, response)
    },
    // 查询第三方信息
    listThirdPartyInfo (params, response) {
        window.vue.$apiAxios.postRequestBody('/databusserver/interfaceManager/listThirdPartyInfo', params, response)
    },
    // 添加第三方信息
    insertThirdPartyInfo (params, response) {
        window.vue.$apiAxios.postRequestBody('/databusserver/interfaceManager/insertThirdPartyInfo', params, response)
    },
    // 修改第三方信息
    updateThirdPartyInfo (params, response) {
        window.vue.$apiAxios.postRequestBody('/databusserver/interfaceManager/updateThirdPartyInfo', params, response)
    },
    // 删除第三方信息
    deleteThirdPartyInfo (params, response) {
        window.vue.$apiAxios.get('/databusserver/interfaceManager/deleteThirdPartyInfo', params, response)
    }

}
